export const stringify = (obj: Object) => {
  const entries = Object.entries(obj).filter(([, v]) => v != null);
  const stringEntries: [string, string][] = entries.map(([k, v]) => [
    k,
    String(v),
  ]);
  return new URLSearchParams(stringEntries).toString();
};
